



export default function Visit({ visit }) {
	return (
		<div className="bg-white rounded-[10px] p-[10px]">
			<div className="flex flex-row justify-between">
				<div className="font-Vazir-400 text-[14px] text-midGray">{visit.doctor_name}</div>
				<div className="spacer p-[5px]"></div>
				<div className="font-Vazir-400 text-[14px] text-midGray">{visit.j_start_datetime}</div>
			</div>
		</div>
	)
}
